import React, {useCallback, useContext, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderFilter} from '@pb/kit-component-filters';
import {LocaleContext} from '@pb/kit-context-locale';

import {getHeader} from '../../../utils';
import {activePlatformAlertsStateActions, activePlatformAlertsStateSelector} from '../../slices/active-platform-alerts-state.slice';
import {activePlatformAlertsResultSelector} from '../../slices/active-platform-alerts.slice';
import {ActivePlatformAlertsSortField} from '../../typedef';

import {AlertMessageFilter} from './alert-message.filter';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

export const AlertMessageHeader = () => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(activePlatformAlertsStateSelector);
    const data = useSelector(activePlatformAlertsResultSelector);
    const [message, setMessage] = useState(
        cacheKeys.filters.message,
    );

    const {locale} = useContext(LocaleContext);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        const sortCriteria = {
            direction: direction as SortDirection,
            field: ActivePlatformAlertsSortField.ALERT_MESSAGE,
        };

        dispatch(activePlatformAlertsStateActions.setSortCriteria(sortCriteria));
    }, [dispatch]);

    const applyFilter = useCallback(() => {
        const filters = {...cacheKeys.filters, message};

        dispatch(activePlatformAlertsStateActions.setFilters(filters));
    }, [cacheKeys.filters, message, dispatch]);

    const clearFilter = useCallback(() => {
        const {message: _message, ...filters} = cacheKeys.filters;

        dispatch(activePlatformAlertsStateActions.setFilters(filters));
    }, [cacheKeys.filters, dispatch]);

    const caption = useMemo(() => getHeader(locale, data?.totalCount), [data?.totalCount, locale]);

    return (
        <SortHeaderFilter
            filterActive={!!cacheKeys.filters?.message}
            sortable={true}
            caption={caption}
            direction={cacheKeys.sortCriteria.field === ActivePlatformAlertsSortField.ALERT_MESSAGE
                ? cacheKeys.sortCriteria.direction
                : undefined}
            defaultDirection={SortDirections.ASC}
            onSort={sort}
            onApply={applyFilter}
            onReset={clearFilter}>
            <AlertMessageFilter
                message={message as string}
                onChange={setMessage}
            />
        </SortHeaderFilter>
    );
};
